import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface RequireMatterCodeUpdateProps {
  requireMatterCode: boolean;
}

export const useUpdateRequireMatterCode = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const updateRequireMatterCode = async (data: RequireMatterCodeUpdateProps) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data,
    });

    const response = await fetch(`${APIBaseChronos}/api/org/require-matter-code`, fetchConfig);

    if (!response.ok) {
      throw new Error('Failed to update matter code setting');
    }
  };

  return useMutation({
    mutationFn: updateRequireMatterCode,
    onSuccess: () => {
      // The flag lives on user.organisation (read during matter creation), so refresh
      // the user context as well as any org-by-id consumers.
      queryClient.invalidateQueries([QueryEntity.User]);
      queryClient.invalidateQueries([QueryEntity.OrganisationById]);
    },
  });
};
